import { useState } from "react";

const UpdateEmail = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // Email validation function
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const saveEmail = async () => {
    setMessage("");

    if (!email.trim()) {
      setMessage("❌ Please enter an email address.");
      return;
    }

    if (!isValidEmail(email)) {
      setMessage("❌ Please enter a valid email format.");
      return;
    }

    const token = localStorage.getItem("authToken");
    if (!token) {
      setMessage("❌ You are not authenticated. Please login.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch("https://backend.aktcorp.com/admin/update-email", {
        method: "PUT", // Use PUT if your backend expects it
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("✅ Email updated successfully!");
        setEmail("");
      } else {
        setMessage(`❌ ${data.error || data.message || "Error updating email."}`);
      }
    } catch (err) {
      setMessage("❌ Network error while updating email.");
    } finally {
      setLoading(false);
      setTimeout(() => setMessage(""), 5000);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-700 to-gray-900">
      <div className="p-8 mt-10 w-full max-w-lg bg-white shadow-2xl rounded-3xl text-center border border-gray-300">
        <h2 className="text-3xl font-bold text-gray-900">Update Email</h2>

        <input
          type="email"
          value={email}
          onChange={handleEmailChange}
          placeholder="Enter New Email"
          className="mt-6 border border-gray-500 p-3 w-full rounded-lg bg-white text-gray-900"
          disabled={loading}
        />

        {!loading ? (
          <button
            onClick={saveEmail}
            className="w-full mt-6 bg-blue-600 text-white font-bold py-3 rounded-xl hover:bg-blue-700"
          >
            Update Email
          </button>
        ) : (
          <div className="w-8 h-8 border-4 border-t-transparent border-blue-600 rounded-full mx-auto mt-6 animate-spin"></div>
        )}

        {message && (
          <p
            className={`text-sm mt-4 font-medium ${
              message.startsWith("✅") ? "text-green-500" : "text-red-500"
            }`}
          >
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default UpdateEmail;
